import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from 'rebass';
import Candidate from 'types/candidates';
import PendingCandidatePost from './PendingCandidatePost';

interface NewCandidatesList {
  candidatesList: Candidate[];
}

const NewCandidatesList: React.FC<NewCandidatesList> = ({ candidatesList }): JSX.Element => {
  const loading = useSelector<any, boolean>(state => state.loading);
  return loading ? (
    <Flex justifyContent="center" alignItems="center">
      Loading...
    </Flex>
  ) : (
    <Flex width="100%" justifyContent="space-between" flexWrap="wrap">
      {candidatesList.map((candidate: Candidate) => (
        <PendingCandidatePost key={candidate.id} candidate={candidate} />
      ))}
    </Flex>
  );
};

export default NewCandidatesList;
